// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3wnrd","noInteraction":"EventWrapper_noInteraction__20JVa"};